import { createSelector } from '@ngrx/store';

import { selectProcessingModuleState } from '../../../../store/selectors/selector';

export const offCycleSelector = createSelector(
  selectProcessingModuleState,
  (state) => state?.offCycle
);
